import React,{ useEffect } from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/styles"


const useStyles = makeStyles(theme => ({
  root: {
    top: 0,
    fontSize: "16px",
    fontFamily:"Proxima Nova,Roboto,Helvetica,Arial,sans-serif",
    color : 'white',
    textAlign: "center",
    backgroundColor:'rgb(167, 199, 187)',
    marginTop: "0px",
    padding: '1px',
  },
  banner:{
 display: "block",
  padding: "15px 0px 5px 21.5px",
  marginTop:"0px",
  marginBottom: "1px",

  },
  imgcovid:{

    position: "relative",
    height:"30px",
    width:"30px", 
    marginTop: "12px",
  },


}))




export default injectIntl(props => {
 
  // const [open, setOpen] = useState(true)
  // const [cartOpen, setCartOpen] = useState(false)
  // const [mainMenuValue, mainMenuSetValue] = useState()
  const { intl } = props

 
  // Items of the menu (menuItems object)

  const i18nmessages = intl.messages

  const classes = useStyles()
  return (
    <div
    className={classes.root}>
    <div >
    
      <p className={classes.banner}>{i18nmessages.locationAlertMsg}</p>
      </div>
     
    </div>
  )
})
